import { render, staticRenderFns } from "./Restricted.vue?vue&type=template&id=23589d3f&scoped=true&"
import script from "./Restricted.vue?vue&type=script&lang=js&"
export * from "./Restricted.vue?vue&type=script&lang=js&"
import style0 from "./Restricted.vue?vue&type=style&index=0&id=23589d3f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23589d3f",
  null
  
)

export default component.exports